import BaseRequest from './index'

class WithdrawalService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.makeWithdrawal = this.makeWithdrawal.bind(this)
    this.getWithdrawalOtp = this.getWithdrawalOtp.bind(this)
  }

  async makeWithdrawal(data: any) {
    return await this.api.post('/user/withdraw', data)
  }

  async getWithdrawalOtp() {
    return await this.api.get('/user/withdraw/otp')
  }
}

const withdrawalService = new WithdrawalService()

export default withdrawalService
